import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import "./Footer.css";
import pinkmoonFullLogo from "../assets/assets/pinkmoon-full-logo.png";
import PhoneDisplay from "../components/PhoneDisplay";
import EmailDisplay from "../components/EmailDisplay";

const Footer = () => {
  return (
    <footer className="footer-dark">
      <div className="footer-dark-container">
        {/* Column 1: Brand Info & Company Summary (Matching Image 1) */}
        <div className="footer-col footer-col-brand">
          <div className="footer-brand-header">
            <img src={pinkmoonFullLogo} alt="PINKMOON Technologies" className="footer-brand-logo-img" />
          </div>
          <p className="footer-brand-desc">
            PINKMOON Technologies is an innovative global IT consulting firm committed to
            delivering next-generation digital solutions, custom software engineering, and AI strategies
            across global markets.
          </p>

          <div className="footer-tag-badges">
            <span className="footer-tag-badge">IT CONSULTING</span>
            <span className="footer-tag-badge">CUSTOM SOFTWARE</span>
            <span className="footer-tag-badge">AI INNOVATION</span>
          </div>
        </div>

        {/* Column 2: Services List (Matching Image 1) */}
        <div className="footer-col">
          <h4 className="footer-col-title">SERVICES</h4>
          <ul className="footer-link-list">
            <li><a href="/services">AI & Machine Learning</a></li>
            <li><a href="/services">Custom Software Engineering</a></li>
            <li><a href="/services">Cloud & DevOps Solutions</a></li>
            <li><a href="/services">Web & Mobile Development</a></li>
            <li><a href="/services">Data Engineering & Analytics</a></li>
            <li><a href="/services">Production Support & QA</a></li>
          </ul>
        </div>

        {/* Column 3: Quick Links List (Matching Image 1) */}
        <div className="footer-col">
          <h4 className="footer-col-title">QUICK LINKS</h4>
          <ul className="footer-link-list">
            <li><a href="/#about-section">About Pinkmoon</a></li>
            <li><a href="/#products-section">Our Products</a></li>
            <li><a href="/#services">Services Portfolio</a></li>
            <li><a href="/#sectors">Sectors</a></li>
            <li><a href="https://ulearn.pinkmoontech.com/" target="_blank" rel="noopener noreferrer">Career Openings</a></li>
            <li><a href="/contact">Contact Us</a></li>
          </ul>
        </div>

        {/* Column 4: Contact Details (Matching Image 1) */}
        <div className="footer-col footer-col-contact">
          <h4 className="footer-col-title">CONTACT</h4>

          <div className="footer-contact-item">
            <MapPin size={16} className="contact-icon" />
            <div className="contact-details">
              <strong>Vijayawada:</strong> 1st Floor, Kunapa Reddy Residency, Ashok Nagar, Vijayawada - 520007, AP
            </div>
          </div>

          <div className="footer-contact-item">
            <MapPin size={16} className="contact-icon" />
            <div className="contact-details">
              <strong>Hyderabad:</strong> 6th Floor, Sprint Business Center, Jayabheri Silicon Tower, Kothaguda, TS
            </div>
          </div>

          <div className="footer-contact-item">
            <MapPin size={16} className="contact-icon" />
            <div className="contact-details">
              <strong>USA:</strong> 2386, Summer Street, Stamford, CT 06905, USA
            </div>
          </div>

          <div className="footer-contact-item">
            <Phone size={16} className="contact-icon" />
            <div className="contact-details">
              <PhoneDisplay phone="+91 73962 53199" />
            </div>
          </div>

          <div className="footer-contact-item">
            <Mail size={16} className="contact-icon" />
            <div className="contact-details">
              <EmailDisplay email="info@pinkmoontech.com" />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar: Copyright (Centered) */}
      <div className="footer-dark-bottom-bar">
        <div className="footer-bottom-container">
          <div className="footer-copyright-text">
            © 2026 PINKMOON Technologies Pvt. Ltd. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
